import { Operator } from "./operator";

export class Merchant {
    constructor(id : string, name : string){
        this.id = id;
        this.name = name;
    }
    id : string = '';
    name : string = '';
}

export class MerchantOperatorContainer{
    merchant : Merchant = new Merchant('', '');
    operator : Operator = new Operator('','');
}
